// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeWeatherResistant: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#666", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M6.469 6.61a1.265 1.265 0 0 1 2.341-.67.422.422 0 0 0 .645.086.984.984 0 0 1 1.649.622.42.42 0 0 0 .42.38h.005a1.126 1.126 0 0 1 0 2.25H6.365l-.018-.001a1.05 1.05 0 0 1-1.003-1.051c0-.498.344-.916.81-1.027a.42.42 0 0 0 .322-.455 1 1 0 0 1-.007-.136M7.734 4.5A2.11 2.11 0 0 0 5.63 6.492a1.897 1.897 0 0 0 .638 3.628q.03.005.061.005h5.203a1.968 1.968 0 0 0 .343-3.908 1.828 1.828 0 0 0-2.623-1.074A2.1 2.1 0 0 0 7.734 4.5M6.47 10.688a.42.42 0 0 0-.422.421v1.407a.42.42 0 1 0 .844 0v-1.407a.42.42 0 0 0-.422-.421m3.375 0a.42.42 0 0 0-.422.421v1.407a.42.42 0 1 0 .844 0v-1.407a.42.42 0 0 0-.422-.421m-1.266.984a.42.42 0 1 0-.844 0v1.406a.42.42 0 1 0 .844 0zm2.953-.422a.42.42 0 0 0-.422.422v1.406a.42.42 0 1 0 .844 0v-1.406a.42.42 0 0 0-.422-.422"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeWeatherResistant);
